<template>
  <section class="views">
    <!-- header -->
    <headers select="2"></headers>
    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
      <div class="posters_ewm" v-if="false">
        <div class="ewm">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/csewm.png')" alt="" />
            </div>
            <div class="ewm3_value">掃碼報名比賽</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 比赛类型Tab -->
    <!-- <div class="competition-types">
      <div class="type-tabs">
        <div
          v-for="item in competitionType"
          :key="item.value"
          @click="changeCompetition(item.value)"
          :class="{ active: item.value === currentCompetition }"
          class="tab-item"
        >
          {{ item.title }}
        </div>
      </div>
    </div> -->

    <div v-if="currentCompetition === '1'" class="content">
      <div class="viewsBoxTab">
        <div class="viewsTab">
          <ul>
            <li
              v-for="(item, index) in gradeColumns"
              :key="index"
              @click="tabBut(index)"
              :class="select === index ? 'select' : ''"
            >
              <div>{{ item.name }}</div>
              <div>({{ item.fzhu }})</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="viewsList">
        <div v-for="item in gradeColumns[select].pdf"
          :key="+new Date()"
          class="animate__animated animate__bounceInLeft"
        >
          <div class="item-box" @click="pdfBut(item)">{{ item.name }}</div>
          <p class="tip">{{ item.tip }}</p>
        </div>
      </div>
    </div>

    <div v-else class="content">
      <div class="viewsList">
        <div class="animate__animated animate__bounceInLeft">
          <div class="item-box" @click="openPdf">比賽誦材下載</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
export default {
  name: "signup",
  data() {
    return {
      gradeColumns: [
        {
          name: "幼稚園初級組",
          fzhu: "K1-K2",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/546969789e7cb1cac8be057ef35f6362.pdf",
              tip: '第五屆「曾憲備·紫荊盃」幼稚園初級組_K1-K2_誦材篇目',
            },
          ],
        },
        {
          name: "幼稚園高級組",
          fzhu: "K3",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2026-01/5a085aa1311c0d56383b8ab595d8bb00.pdf",
              tip: '第五屆「曾憲備·紫荊盃」幼稚園高級組_K3_誦材篇目',
            },
          ],
        },
        {
          name: "小學初級組",
          fzhu: "P1-P2",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/7957a6aad2647bc3aadf4e57142a7d61.pdf",
              tip: '第五屆「曾憲備·紫荊盃」小學初級組_P1-P2_誦材篇目',
            },
          ],
        },
        {
          name: "小學中級組",
          fzhu: "P3-P4",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/1408070d614928fe444e2f16fa545e1f.pdf",
              tip: '第五屆「曾憲備·紫荊盃」小學中級組_P3-P4_誦材篇目',
            },
          ],
        },
        {
          name: "小學高級組",
          fzhu: "P5-P6",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/7c732a97cf0dae05e473377fa6718504.pdf",
              tip: '第五屆「曾憲備·紫荊盃」小學高級組_P5-P6_誦材篇目',
            },
          ],
        },
        {
          name: "中學組",
          fzhu: "S1-S6",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/bc3a9d2b6d2f72b2131bff1e0e483d5a.pdf",
              tip: '第五屆「曾憲備·紫荊盃」中學組_S1-S6_誦材篇目',
            },
          ],
        },
        {
          name: "閃亮組",
          fzhu: "特殊學校",
          pdf: [
            {
              name: "比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/cd1e2ac630cc51917a208022d6a60d0e.pdf",
              tip: '第五屆「曾憲備·紫荊盃」閃亮組_特殊學校_誦材篇目',
            },
          ],
        },
        {
          name: "飛躍組",
          fzhu: "非華裔",
          pdf: [
            {
              name: "飛躍A組-幼稚園-比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/892fd97b53ecc502ea8b157c5b777b34.pdf",
              // tip: '第五屆「曾憲備·紫荊盃」飛躍A組_幼稚園_誦材篇目',
            },
            {
              name: "飛躍B組-小學-比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/d4926149ea935e1a5812bb00e8e1ddbe.pdf",
              // tip: '第五屆「曾憲備·紫荊盃」飛躍B組_小學_誦材篇目',
            },
            {
              name: "飛躍C組-中學-比賽誦材下載",
              url:
                "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/309e14b9a58ff953788b3f26dc9e235c.pdf",
              tip: '第五屆「曾憲備·紫荊盃」飛躍組_誦材篇目',
            },
          ],
        },
      ],
      select: 0,
      // 比赛类型
      currentCompetition: '1',
      competitionType:[
        {
          title:'個人賽',
          value:'1'
        },
        {
          title:'團體赛',
          value:'2'
        },
      ],
    };
  },
  computed: {},
  components: {
    headers,
  },
  methods: {
    changeCompetition(value) {
      this.currentCompetition = value
    },
    getPdf(e) {
      this.$axios({
        url: e.url,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          this.$toast.clear();
          this.$toast.success("開始下載");
          // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
          const blob = new Blob([response.data], { type: "application/pdf" });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob); // 创建下载链接
          downloadElement.href = href;
          downloadElement.download = e.name; // 文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 下载
          document.body.removeChild(downloadElement); // 下载完成后移除元素
          window.URL.revokeObjectURL(href); // 释放占用的内存空间
        })
        .catch((error) => {
          this.$toast.clear();
          console.error(error); // 处理异常情况
        });
    },
    pdfBut(e) {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '誦材暫未開放下載',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })

      if (e.url) {
        // this.getPdf(e);
        window.open(e.url, "_blank");
      } else {
        this.$dialog
          .alert({
            title: "提示",
            message: "決賽誦材暫未開放下載",
            confirmButtonText: "確認",
          })
          .then(() => {
            // on close
          });
      }
    },
    openPdf() {
      window.open('https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/image/a9f0bce3cecc7699b4388f119042463e.pdf', "_blank");
    },
    tabBut(e) {
      this.select = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.competition-types {
  position: sticky;
  top: 80px;
  width: 100%;
  margin-bottom: 30px;
  background: #d34a00;
  z-index: 99999;
  .type-tabs {
    display: flex;
    justify-content: center;
    gap: 10px;
    .tab-item {
      min-width: 120px;
      padding: 20px 10px;
      color: #fff;
      cursor: pointer;
      font-size: 16px;

      &.active {
        font-weight: 600;
        color: #903300;
        background-image: url("~@/assets/image/hodgepodge/tabbuttom.png");
        background-size: 100% 100%;
        transform: scale(1.2)
      }
    }
  }
}

.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;

  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      width: 1024px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: right;

      .ewm {
        width: 161px;
        height: 189px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 8px;
        box-sizing: border-box;

        .ewm2 {
          width: 100%;
          height: 100%;
          padding: 6px;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;

          .ewm3 {
            width: 132px;
            height: 132px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 19px;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    margin: auto;

    .viewsBoxTab {
      width: 100%;
      position: relative;
      background: linear-gradient(to bottom, #ffe082 0%, #efbb69 100%);

      .viewsTab {
        width: 100%;
        max-width: 1024px;
        margin: auto;
        box-sizing: border-box;
        display: flex;

        ul {
          width: 100%;
          height: 64px;
          display: inline-flex;
          justify-content: center;
          align-items: center;

          li {
            width: 152px;
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-wrap: wrap;
            font-family: PingFang SC-Semibold, PingFang SC;
            flex: 0 0 auto;
            background: linear-gradient(to bottom, #ffe082 0%, #efbb69 100%);
            // background: #d34a00; 
            cursor: pointer;

            div {
              width: 100%;
            }

            div:nth-child(1) {
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #903300;
              line-height: 20px;
            }

            div:nth-child(2) {
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #903300;
              line-height: 15px;
            }
          }

          .select {
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            background: linear-gradient(135deg, #ff8a3a 0%, #d34a00 100%);
            border-radius: 5px;
            box-shadow: 0 8px 20px rgba(211, 74, 0, 0.18), inset 0 -4px 12px rgba(255, 255, 255, 0.06);
            transform: translateZ(0) scale(1.04);
            transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
            position: relative;
            overflow: hidden;
            // padding: 10px 0;

            &::after {
              content: "";
              position: absolute;
              left: 10%;
              right: 10%;
              bottom: 6px;
              height: 6px;
              background: rgba(255, 255, 255, 0.08);
              border-radius: 4px;
              filter: blur(6px);
              pointer-events: none;
            }
          
            // padding: 8px 0;
            // background: url("~@/assets/image/hodgepodge/tabbuttom.png")
            //   no-repeat;
            // background-size: 100% 100%;

            div:nth-child(1) {
              font-size: 16px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #fff;
              line-height: 20px;
            }

            div:nth-child(2) {
              font-size: 13px !important;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600 !important;
              color: #fff;
              line-height: 15px;
            }
          }
        }

        @media (max-width: 1024px) {
          ul {
            display: flex;
            justify-content: flex-start;
            overflow-x: auto;
            padding: 0 16px;
            gap: 6px;
            -webkit-overflow-scrolling: touch;
          }
        }
      }
    }

    .viewsList {
      width: 100%;
      max-width: 1024px;
      margin: 64px auto 50px auto;
      padding: 0.32rem;
      box-sizing: border-box;

      .item-box {
        width: 640px;
        height: 124px;
        margin: auto;
        background: #fff8de;
        box-shadow: 0px 0px 4px 0px rgba(126, 56, 0, 0.26);
        border: 4px solid #fff0e1;
        border-radius: 16px;
        margin-bottom: 20px;
        font-size: 24px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ff782f;
        line-height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .tip {
        color: #fff;
        font-size: 14px;
      }
    }
  }
}
</style>
